import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppTopBar2 from "./common/app-top-bar2";
import AppLoading from "./common/app-loading";
import {
  Button,
  Box,
  Card,
  CardActions,
  CardContent,
  Chip,
  Divider,
  TablePagination,
  List,
  ListItem,
  ListItemButton,
  Paper,
  Typography,
  TextField,
  Grid,
  Table,
  TableContainer,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import LinearProgress from "@mui/material/LinearProgress";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { AppHelper } from "../AppHelper";
import SpaCheck from "./common/spa-check";
import PopUsageList from './pop-usage-list';

const dayjs = require("dayjs");

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box>
        <Typography
          variant="body2"
          color="text.secondary"
          fontSize={"0.7rem"}
          sx={{
            color: props.recSelected == 1 ? "#fff" : "text.secondary",
          }}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
const headCellsExercise = [
  { id: "rowIndex", numeric: true, disablePadding: false, label: "#", align: "center" },
  { id: "email", numeric: false, disablePadding: false, label: "EMAIL" },
  { id: "name", numeric: false, disablePadding: false, label: "PROFILE" },
  { id: "grade", numeric: false, disablePadding: false, label: "GRADE", align: "center" },
  { id: "score", numeric: false, disablePadding: false, label: "SCORE", align: "center" },  
  { id: "exercise", numeric: false, disablePadding: false, label: "EXERCISE", align: "center" },  
  { id: "tCode", numeric: false, disablePadding: false, label: "SUBMITTED ON", align: "center" },  
  { id: "action", numeric: false, disablePadding: false, label: "ACTION", align: "center" },  
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = headCellsExercise;

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align || headCell.numeric ? "center" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function PageSaExerciseList() {
  const navigate = useNavigate();
  const oUser = AppHelper.userCacheGet();

  const [isLoading, setIsLoading] = useState(true);
  const [exerciseList, setExerciseList] = useState([]);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const [viewMode, setViewMode] = React.useState("LIST");
  const [refreshList, setRefreshList] = React.useState(false);
  const [recExercise, setRecExercise] = React.useState({});

  const [tblOrderExercise, setTblOrderExercise] = React.useState("desc");
  const [tblOrderByExercise, setTblOrderByExercise] = React.useState("tCode");
  const [filterExercise, setfilterExercise] = React.useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);  
  const [isPopUsageOpen, setIsPopUsageOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [accounts, setAccounts] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    AppHelper.apiAuditPost("P-SA-EX", "");
  }, []);

  useEffect(() => {
    if (!oUser) {
      navigate("/login");
      return;
    }
  });

  useEffect(() => {
    setIsLoading(true);
  
    const fetchExerciseList = async () => {
      exerciseList.splice(0);
      setIsLoading(true);
      var _res = await AppHelper.apiPost("api/exercise/sentenceTransform/list/all", {
        token: oUser.token,
      });      
	
      if (!_res || !_res.status) {  
        return;
      }
      _res.data.forEach((r, iRec) => {
        var _ts = dayjs(r.timestampUtc);
        r.rowIndex = 0;
		r.exerciseCount = r.exerciseCount == 0 ? "-" : r.exerciseYCount + "/" + r.exerciseCount;
        r.tCode = _ts.format("YYYYMMDDHHmmss");
        r.tTitle = _ts.format(`DD MMM 'YY hh:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` + _ts.format('DD MMM YYYY');
       
        r.email = r.profile ? r.profile.email : "-";
        r.name = r.profile ? r.profile.name : "-";
		r.grade = r.profile ? r.profile.grade : "-";
		
		let totalQuestions = 0;
        let totalStatus1 = 0;
		r.pages.forEach(page => {
            page.questions.forEach(question => {
                totalQuestions++;
                if (question.status === 1) {
                    totalStatus1++;
                }
            });
        });

        r.score = totalStatus1 + "/" + totalQuestions;
		
      });
      var _list = [...AppHelper.sortList(_res.data, "tCode", 2)];
      setExerciseList(_list);
    };       
    const fetchIAM = async () => {
      if (!oUser) {
        navigate("/login");
        return;
      }
      var _res = await AppHelper.apiPost("api/account/iam", {
        token: oUser.token,
      });
      if (!_res || !_res.status || !_res.data || !_res.data.isSa) {
        nonSaView();
        return;
      }
      fetchExerciseList();
    };
    fetchIAM();
    const fetchAccounts = async () => {
      setIsLoading(true);
      try {
            var _res = await AppHelper.apiPost("api/account/list/sa", {
              token: oUser.token,
            });
          setAccounts(_res.data); 
      } catch (error) {
          console.error('Error fetching accounts:', error);
      } finally {
      }
  };
  fetchAccounts();
  setIsLoading(false);
  }, [refreshList]);

  const onExerciseSelect = (arg) => {
    setViewMode("VIEW");
    setRecExercise(arg);
    var _list = exerciseList;
    _list.forEach((s) => {
      s.selected = s.essayId == arg.essayId ? "1" : "0";
    });
  };
  const exerciseDelete = async (arg) => {
    if (!window.confirm("Are you sure you want to delete the Exercise?")) return;
    setIsLoading(true);
    var _res = await AppHelper.apiPost("api/exercise/sentenceTransform/delete", {
      token: oUser.token,
      exerciseId: arg.exerciseId,
    });
    if (!_res || !_res.status) {
      alert("ERROR: Failed to delete!");
      setIsLoading(false);
      return;
    }
    setRefreshList(!refreshList);
  };

  const cardView = () => {
    navigate("/sa");
  };
  const nonSaView = () => {
    setViewMode("NON-SA");
  };
  const mobileOpenClick = (arg) => {
    setMobileOpen(!mobileOpen);
  };
  const back2Home = () => {
    navigate("/");
  };
  const listSortAndfilterExercise = () => {
	setIsLoading(true);
    var _list = [...exerciseList];
    if (filterExercise && filterExercise.length > 0) {
      var _filterText = filterExercise.toLowerCase();
      _list = _list.filter(
        (r) =>
          r.type.toLowerCase().includes(_filterText) ||
          r.email.toLowerCase().includes(_filterText) ||          
		  r.name.toLowerCase().includes(_filterText) ||
		  r.grade.toLowerCase().includes(_filterText)
      );
    }
	setPage(0);

    const res = stableSort(_list, getComparator(tblOrderExercise, tblOrderByExercise));
	
	setIsLoading(false);
	return res;
  };
  const filterExerciseChange = (event) => {
    setfilterExercise(event.target.value);
  };

  const visibleExercises = React.useMemo(
	() => listSortAndfilterExercise(),
	
    [exerciseList, tblOrderExercise, tblOrderByExercise, filterExercise]
  );
  const tblSortExercise = (event, property) => {
    const isAsc = tblOrderByExercise === property && tblOrderExercise === "asc";
    setTblOrderExercise(isAsc ? "desc" : "asc");
    setTblOrderByExercise(property);
  };

  const handleViewUsageClick = (row) => {
    const accountId = accounts.find(account => account.profileId === row.profileId)?.accountId;
    if (accountId) {
      setSelectedAccount(accountId);
      setIsPopUsageOpen(!isPopUsageOpen);
    } else {
    }
  };

  const popUsageListClose = (questionId) => {
    setIsPopUsageOpen(false);
  }

  return (
    <Box sx={{ display: "flex" }}>
      <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} />
      {isLoading ? (
        <AppLoading />
      ) : (
        <>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: "100%",
              marginTop: "50px",
            }}
          >

            {viewMode == "LIST" && (
              <>
                <Grid container alignItems="center" justifyContent="space-between">
				  <Grid item xs={4} sm={4}>
					<Button onClick={cardView}>&laquo; Back to Overview</Button>
				  </Grid>

				  <Grid item xs={8} sm={8} style={{ display: 'flex', justifyContent: 'flex-end', gap: '16px' }}>
					<TextField
					  value={filterExercise}
					  onChange={filterExerciseChange}
					  id="txtfilterExercise"
					  label=""
					  variant="standard"
					  placeholder="Search"
					  style={{ minWidth: '300px' }}
					/>
					
				  </Grid>
				</Grid>

                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                   
                    <EnhancedTableHead
                      order={tblOrderExercise}
                      orderBy={tblOrderByExercise}
                      onRequestSort={tblSortExercise}
                      rowCount={exerciseList.length}
                      gid="G1"
                    />
                    <TableBody>
                      {visibleExercises
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, iRec) => (
                          <TableRow
                            key={row.exerciseId}
                            sx={{
                            }}
                          >
                            <TableCell align="center" sx={{pr:'2.3rem'}}>{iRec + 1}.</TableCell>
                            <TableCell align="left">
                              {row.profile ? row.email : "-"}
                            </TableCell>
                            <TableCell align="left" sx={{pl:'0.5rem'}}>
                              <Button href={"/exercise/detail/" + row.exerciseId}
                                target="_blank"
                                style={{textTransform: 'none'}}>
                                {row.profile ? row.name : "-"}
                              </Button>
                              <IconButton
                                onClick={() => handleViewUsageClick(row)}
                                label="View usage"
                              >
                                <VisibilityIcon />
                              </IconButton>
                            </TableCell>
							              <TableCell align="center" sx={{pr:'2.3rem'}}>
                              {row.profile ? row.grade : "-"}
                            </TableCell>
							
							<TableCell align="center" sx={{pr:'2.3rem'}}>
                              <Chip color="success" label={row.score} 
																				sx={{height:'20px', 
                                            backgroundColor:'rgb(19, 130, 117)', 
                                            color: 'rgb(255, 255, 255)', 
                                            marginTop: '1px'}}
															/>
                            </TableCell>
                           
							              <TableCell align="center"  sx={{pr:'2.3rem'}}>
                              {row.exerciseCount !== "-" && 
                                <Chip label={row.exerciseCount} 
                                          sx={{height:'20px', 
                                              backgroundColor:'rgb(19, 130, 117)', 
                                              color: 'rgb(255, 255, 255)', 
                                              marginTop: '1px'}}
                                />
                              }
                              {row.exerciseCount === "-" && 
                                <Chip label={row.exerciseCount} 
                                          sx={{height:'20px', 
                                              backgroundColor:'rgb(255, 255, 255)', 
                                              color: 'rgb(0, 0, 0)'}}
															  />}
                            </TableCell>
                           
                            <TableCell align="center" sx={{pr:'2.3rem'}}>{row.tTitle}</TableCell>
                           
                            <TableCell align="center" sx={{pr:'2.3rem'}}>
                              <IconButton
                                onClick={() => exerciseDelete(row)}
                                aria-label="delete"
                              >
                                <DeleteForeverIcon color="error" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={visibleExercises.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </>
            )}

            {viewMode == "NON-SA" && (
              <React.Fragment>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Card variant="outlined">
                      <CardContent>
                        <Typography variant="h5" component="div">
                          Access denied
                        </Typography>
                        <Typography sx={{ mb: 1.5 }} color="text.secondary">
                          &nbsp;
                        </Typography>
                        <Typography variant="body2">
                          This page is only allowed for System Administrators.
                        </Typography>
                      </CardContent>
                      <CardActions>
                        <Button onClick={back2Home} size="small">
                          Back to Home
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                </Grid>
              </React.Fragment>
            )}
          </Box>
        </>
      )}
      <SpaCheck></SpaCheck>
      <PopUsageList
        open={isPopUsageOpen}
        accountId={selectedAccount}
        onClose={popUsageListClose}
      ></PopUsageList>
    </Box>
  );
}
